import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';

export const useArtworkKey = (
  artworkMode: string | undefined,
  key: string | null | undefined
) => {
  const channelArtworkKey =
    useSelector(
      (state: RootState) => state.channel.channelDetails?.artworkKey
    ) || null;
  const [imageKey, setImageKey] = useState<string | null | undefined>();
  const [imageBaseUrl, setImageBaseUrl] = useState<string | undefined>();

  useEffect(() => {
    switch (artworkMode) {
      case 'channel':
        setImageBaseUrl(process.env.REACT_APP_STORAGE_CDN_URL);
        setImageKey(channelArtworkKey);
        break;
      case 'private':
      case 'logo':
        setImageBaseUrl(process.env.REACT_APP_STORAGE_CDN_URL);
        setImageKey(key);
        break;
      case 'image':
        setImageBaseUrl(undefined);
        setImageKey(key);
        break;
      case 'recording':
        setImageBaseUrl(process.env.REACT_APP_STORAGE_CDN_URL);
        setImageKey(key);
        break;
      default:
        setImageBaseUrl(undefined);
        setImageKey(key);
        break;
    }
  }, [setImageKey, setImageBaseUrl, artworkMode, channelArtworkKey, key]);

  return { imageKey, imageBaseUrl };
};
